import type { TransportMode } from '../../../../../models/transport-mode.enum';
import TransportModeIconDarkSquare from '../TransportModeIconDarkSquare';
import { TransportModeHelper } from '../../../../../helpers/transport-mode.helper';

function TransportModeCheckbox({
  transportMode,
  checked,
  className,
  onChange,
}: {
  transportMode: TransportMode;
  checked: boolean;
  className?: string;
  onChange: (transportMode: TransportMode, checked: boolean) => void;
}) {
  function handleChange() {
    onChange(transportMode, !checked);
  }

  return (
    <div className={`transport-mode-checkbox form-check ${className}`}>
      <input id={transportMode} type="checkbox" className="form-check-input" checked={checked} onChange={handleChange} />
      <label htmlFor={transportMode} className="form-check-label fw-normal d-flex align-items-center text-nowrap">
        <TransportModeIconDarkSquare className="transport-mode-checkbox__icon me-1" transportMode={transportMode} overrideAltText="" />
        {TransportModeHelper.translate(transportMode)}
      </label>
    </div>
  );
}

export default TransportModeCheckbox;
